import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import WebSplashScreen from './components/main/WebSplashScreen';

import Home from './pages/Home';
import Login from './pages/main/Login';
import Register from './pages/Register';
import Dashboard from './pages/users/Dashboard';
import MyHorses from './pages/MyHorses';
import SignUp from './pages/SignUp';
import Footer from './components/Footer';
import HorseProfile from './pages/horses/HorseProfile';
import Search from './pages/main/Search';
import PostHorse from './pages/main/PostHorse';
import Profile from './pages/users/Profile'

export default function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000); // Simulate loading delay
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <WebSplashScreen />;
  }

  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <div className="min-h-screen">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/home" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/myhorses" element={<MyHorses />} />
            <Route path="/horses/:id" element={<HorseProfile />} />
            <Route path="/search" element={<Search />} />
            <Route path="/post-horse" element={<PostHorse />} />
            <Route path="/profile" element={<Profile />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </AuthProvider>
  );
}